import { LazyMotion } from 'framer-motion';

const loadFeatures = () => import('./features').then((module) => module.default);

const loadDragFeatures = () => import('./dragFeatures').then((module) => module.default);

export const MotionProvider = ({ children }) => (<LazyMotion features={loadFeatures} strict>{children}</LazyMotion>);

export const DragMotionProvider = ({ children }) => (<LazyMotion features={loadDragFeatures} strict>{children}</LazyMotion>);
